//chapter1
export default {
    id : 8,//chapter number
    title : '08. SBA(Solder Ball Attach) 공정 (2)',//chapter name
    slides : [
        {
            title : 'Intro',
            type : 'intro',
            autoNext : 'N',//Y : yes , N: no
            nextBtn : 'Y',//Y : yes , N: no
            source : 'https://cdn.allwinedu.net/net/contents5/HU12/08/videos/a08.mp4',
        },
        {
            title : 'Today’s Goal',
            type : 'plan',
            autoNext : 'N',//Y : yes , N: no, P : popup
            duration : 20000,// default 20 sec  
            nextBtn : 'Y',//Y : yes , N: no
            body1 : [
                '솔더 볼 접합 공정',
                '표면실장 공정(Surface Mount Technology, SMT)',
            ],
            body2 : [
                '솔더 볼 접합 공정에 대해 설명할 수 있다.',
                '표면실장 공정에 대해 설명할 수 있다.'
            ],
            bgm : "plan.mp3"
        },
        {
            title : 'Lesson',
            type : 'lesson',
            autoNext : 'N',//Y : yes , N: no, P: popup
            nextBtn : 'Y',//Y : yes , N: no
            order : null, // if a chapter have multiple lessons, set order please ex)
            source : 'https://cdn.allwinedu.net/net/contents5/HU12/08/videos/08.mp4',
        },
        {
            title : 'Quiz',
            type : 'quiz',
            quiz : [
                {
                    type : 'ox',
                    title : 'Quiz',
                    question : 'IR Reflow 공정은 특별한 가스를 사용하지 않고 대기 중에서 진행한다.',//html available
                    answer : "2",
                    explain : 'IR Reflow 공정은 N₂ 가스 분위기에서 진행해서 솔더가 잘 접합되도록 한다.'
                },
                {
                    type : 'ox',
                    title : 'Quiz',
                    question : '솔더 볼 접합을 위한 IR Reflow 공정은 furnace 전체를 고온을 균일하게 유지시켜 진행한다.',//html available
                    answer : "2",
                    explain : 'IR Reflow 공정은 furnace를 여러 구간으로 나누어 적절한 온도 분포를 적용하여 진행한다.'
                },
            ],
            quizMask : "../assets/images/quiz_intro.jpg",//quiz mask bg
            quizMaskStart : "../assets/images/quiz_intro_start.png",//quiz mask bg
            quizIntroText : "../assets/images/quiz_intro_text.png",//quiz mask bg
            bgm : "quiz.mp3"
        },
        {
            title : 'Summary',
            type : 'summary',
            autoNext : 'N',//Y : yes , N: no
            duration : 20000,// default 20 sec  
            nextBtn : 'Y',//Y : yes , N: no
            //download : 'sample.pptx',//data folder
            print : false,// true : show, false: hide
            slides : [
                {
                    body : `<ul>
                        <li>솔더 볼 접합 공정 : PCB Strip을 대상으로 Gold Pad 위에 Flux를 도포한 후 그 부위에 솔더 볼을 녹인 후 굳게 하여 PCB와 솔더 볼을 일체화 시켜 주는 공정<br>
                        - PCB 패드에 플럭스를 도포함<br>
                        - 솔더 볼을 PCB의 패드에 올려놓음<br>
                        - PCB를 250℃ 이상의 온도에서 리플로우하는 과정을 통해 솔더 볼을 PCB에 접합함</li>
                    </ul>`
                },
                {
                    body : `<ul>
                        <li>표면실장 공정(Surface Mount Technology, SMT)<br>
                        - 전자제품을 구현하기 위해 반도체 부품을 PCB에 실장하는 공정으로 솔더를 바르는 스크린 프린팅(Screen Printing)<br>
                        - 원하는 반도체 부품을 PCB 위에 위치시키는 칩 마운팅(Chip Mounting)<br>
                        - 반도체 부품과 PCB를 솔더를 통해 고정시키키 위해 온도를 가하는 리플로우(Reflow) 공정으로 진행됨</li>
                    </ul>`
                },
            ],
            bgm : "summary.mp3"
        },
        {
            title : 'Outro',
            type : 'outro',
            source : 'https://cdn.allwinedu.net/net/contents5/HU12/08/videos/a08.mp4',
        },
    ]
}